<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LxyO4h/cover.jpeg?1685203881705" alt="This image is the cover for the book Heaven-defying Elementalist Emperor, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heaven-defying Elementalist Emperor, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>If I become a Deity, who can stop me? In the Elemental World, I am the most supreme.The youth had thought that he would live a blissful life, but who would have thought that his fiancee would betray him on the eve of his wedding. He abandoned him and joined forces with his lover to kill him. He had survived a great disaster. He fell from the sky, killing his way out, and swore to become powerful. He also opened up a forbidden heaven to protect his soul, and a path of cultivation to destroy the mind."Elements flowing in space, please heed my call and release! "Divine Sealing Spell."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ban MuFangTang, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a8b3540